import styled from 'styled-components';
import { theme } from '../../Styles';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  background-color: ${theme.mainDarker};

  @media (max-width: 400px) {
    font-size: 12px;
}  
`;

export const TableData = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: transparent;
  }
  

  @media (max-width: 400px) {
    font-size: 12px;
}  
`;

export const TokenCheckbox = styled.button`
    display: inline-block;
    width: 20px;
    height: 20px;
    z-index: 200;
    font-size: 18px;
    font-weight: 500;
    top: 20px;
    left: 20px;
    line-height: 14px;
    border: 2px solid ${theme.secondary};
    border-radius: 3px;
    color: white;
    background-color: ${props => props.selected == "yes" ? theme.secondary : "transparent"};
`